/*
 * BRINUTI — „30 napos garancia" buborék
 *
 * 3. elemző PDF 7. pontja: a főoldalon ÉS mindenhol, ahol kiírjuk a
 * „30 napos garancia" szöveget, kattintásra jöjjön fel egy pici buborék:
 * „Ha nem tetszik, kérdés nélkül visszautaljuk az árát."
 *
 * Miért szövegkeresés és nem beírt jelölés? A felirat tucatnyi helyen áll:
 * hero bizalmi sor, termékoldali pontok, kosár összesítő, kollekció
 * kártyák, üres kosár — részben a sablonok JSON mezőiből. Egy helyen
 * megírva mindenhol egyformán működik, és nem lehet elfelejteni.
 *
 * A lenyíló GYIK-tételeket (<summary>, <details>) szándékosan kihagyjuk:
 * azok kattintásra amúgy is kinyílnak, ott a buborék csak zavarna.
 */
(function () {
  var KERESETT = '30 napos garancia';
  var UZENET = 'Ha nem tetszik, kérdés nélkül visszautaljuk az árát.';
  var buborek = null;
  var aktiv = null;

  function buborekot() {
    if (buborek) return buborek;
    buborek = document.createElement('div');
    buborek.className = 'bl-garancia-buborek';
    buborek.setAttribute('role', 'tooltip');
    buborek.hidden = true;
    buborek.textContent = UZENET;
    document.body.appendChild(buborek);
    return buborek;
  }

  function elrejt() {
    if (!buborek) return;
    buborek.classList.remove('is-latszik');
    if (aktiv) aktiv.setAttribute('aria-expanded', 'false');
    aktiv = null;
    setTimeout(function () {
      if (!aktiv) buborek.hidden = true;
    }, 200);
  }

  function mutat(elem) {
    var b = buborekot();
    aktiv = elem;
    elem.setAttribute('aria-expanded', 'true');
    b.hidden = false;
    // Előbb megmérjük, aztán pozicionálunk: a buborék a felirat fölé kerül,
    // a képernyő szélén pedig befelé csúszik, hogy ne lógjon ki.
    b.style.left = '0px';
    b.style.top = '0px';
    var e = elem.getBoundingClientRect();
    var m = b.getBoundingClientRect();
    var x = e.left + e.width / 2 - m.width / 2;
    var hatar = 8;
    if (x < hatar) x = hatar;
    if (x + m.width > window.innerWidth - hatar) x = window.innerWidth - hatar - m.width;
    var y = e.top - m.height - 10;
    if (y < hatar) y = e.bottom + 10;
    b.style.left = Math.round(x + window.scrollX) + 'px';
    b.style.top = Math.round(y + window.scrollY) + 'px';
    setTimeout(function () {
      b.classList.add('is-latszik');
    }, 10);
  }

  function kihagyando(elem) {
    if (!elem) return true;
    if (elem.closest('summary, details, script, style, noscript, textarea, option, .bl-garancia, .brinuti-lepesek__cim, .brinuti-ures__bizalom')) return true;
    return false;
  }

  function jelol(gyoker) {
    var sorok = document.createTreeWalker(gyoker, NodeFilter.SHOW_TEXT, {
      acceptNode: function (csomo) {
        if (csomo.nodeValue.indexOf(KERESETT) === -1) return NodeFilter.FILTER_REJECT;
        if (kihagyando(csomo.parentElement)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var talalatok = [];
    var cs;
    while ((cs = sorok.nextNode())) talalatok.push(cs);

    talalatok.forEach(function (csomo) {
      var darabok = csomo.nodeValue.split(KERESETT);
      var toredek = document.createDocumentFragment();
      darabok.forEach(function (d, i) {
        if (i > 0) {
          var jel = document.createElement('span');
          jel.className = 'bl-garancia';
          jel.setAttribute('tabindex', '0');
          jel.setAttribute('role', 'button');
          jel.setAttribute('aria-expanded', 'false');
          jel.textContent = KERESETT;
          toredek.appendChild(jel);
        }
        if (d) toredek.appendChild(document.createTextNode(d));
      });
      csomo.parentNode.replaceChild(toredek, csomo);
    });
  }

  function inditas() {
    jelol(document.body);
  }

  document.addEventListener('click', function (esemeny) {
    var jel = esemeny.target.closest ? esemeny.target.closest('.bl-garancia') : null;
    if (jel) {
      esemeny.preventDefault();
      esemeny.stopPropagation();
      if (aktiv === jel) elrejt();
      else mutat(jel);
      return;
    }
    if (aktiv) elrejt();
  });

  document.addEventListener('keydown', function (esemeny) {
    if (esemeny.key === 'Escape' && aktiv) elrejt();
    if ((esemeny.key === 'Enter' || esemeny.key === ' ') && esemeny.target.classList &&
        esemeny.target.classList.contains('bl-garancia')) {
      esemeny.preventDefault();
      if (aktiv === esemeny.target) elrejt();
      else mutat(esemeny.target);
    }
  });

  window.addEventListener('resize', elrejt);
  window.addEventListener('scroll', elrejt, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inditas);
  } else {
    inditas();
  }

  // A kosárfiók és a Teeinblue utólag is rajzol szöveget: figyeljük a DOM-ot.
  var idozit = null;
  new MutationObserver(function () {
    if (idozit) clearTimeout(idozit);
    idozit = setTimeout(inditas, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
